/** A country-hidden tab must also be closed to a direct query-string URL. */
export const companyTabForCountry = (tab: string, isIreland: boolean): string =>
  isIreland && tab === 'HMRC' ? 'REVENUE_SETTING' : tab;
